/**
 * Mobile Filter Sticky
 * Removes all special positioning during drawer transition
 * Re-applies sticky after transition completes
 * Handles page updates after filter selections
 */
(function() {
  'use strict';

  var isTransitioning = false;

  function getFilterBar() {
    return document.querySelector('.collection-filter');
  }

  function handleDrawerClose() {
    if (isTransitioning) return;
    
    var filterBar = getFilterBar();
    if (!filterBar) return;
    
    isTransitioning = true;
    
    // Remove sticky positioning completely during transition
    filterBar.style.position = 'static';
    
    // Re-apply sticky after drawer animation completes
    setTimeout(function() {
      var currentFilterBar = getFilterBar();
      if (currentFilterBar) {
        currentFilterBar.style.position = '';
      }
      isTransitioning = false;
    }, 400);
  }

  function init() {
    if (window.innerWidth > 768) return;

    // Watch for drawer open/close
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName !== 'class') return;
        
        var hadLockScroll = mutation.oldValue && mutation.oldValue.indexOf('lock-scroll') !== -1;
        var hasLockScroll = document.documentElement.classList.contains('lock-scroll');
        
        // Drawer closing
        if (hadLockScroll && !hasLockScroll) {
          handleDrawerClose();
        }
      });
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
      attributeOldValue: true
    });
  }

  // Initialize
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  // Re-initialize after Shopify AJAX updates
  document.addEventListener('shopify:section:load', init);
})();
